export default{
    getChatroomList(state){
        return state.roomList;
    },
}
